import { RootState, Alert, Token } from './types';

export const getToken = (state: RootState): Token => state.login.authentication.token;
export const isLoggingIn = (state: RootState): boolean => state.login.authentication.loggingIn;
export const isLoggedIn = (state: RootState): boolean => getToken(state) !== '';
export const getAlert = (state: RootState): Alert => state.login.alert;
